import { render, staticRenderFns } from "./box8.vue?vue&type=template&id=16ad8b6e&scoped=true&"
import script from "./box8.vue?vue&type=script&lang=js&"
export * from "./box8.vue?vue&type=script&lang=js&"
import style0 from "./box8.vue?vue&type=style&index=0&id=16ad8b6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad8b6e",
  null
  
)

export default component.exports